window.s2AsyncInit = function()
  {
   S2V5Obj.init({
   targetID: "sa_refer_friend_sale_track",
    //siteID:2115540,
    //incentiveID:2746,
    siteID:8989131,
    incentiveID:1,
    email_id:'glenboth.sa@gmail.com',
    sale_amount:'1',
     socialType:'2'
   });
  };

  (function(d){
  var id = 'socialannex-s2core'; ref = d.getElementsByTagName('HEAD')[0];
  if (d.getElementById(id)) {return;}
  var s2core = d.createElement('script'); s2core.id = id; s2core.async = true;
  alert('site_id ==>' +site_id);   
  alert('sale_amount===>'+sale_amount);    
  alert('order_id==>'+order_id);
  alert('email_id');
  s2core.src = "https://c.socialannex.com/c-sale-track/?site_id=siteID&order_id=order_id&sale_amount=sale_amount&email_id=email_id";
  ref.parentNode.insertBefore(s2core, ref);
  
 }(document));